import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Snackbar,
  TextField,
  Alert,
  Typography,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { deleteAdmin } from 'src/api';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';

const DeleteAdminForm = () => {
  const { logoutUser } = commonReducerAction;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { startLoading, stopLoading } = loaderReducerAction;
  const resons = [
    'Not enough features avaliable',
    'Encounteered technical problems or bugs',
    'Switching to another gym management service',
    'Difficult to navigate or use',
    'Concerns about data privacy',
    'No longer using this application'
  ];

  const [other, setOther] = useState(false);
  const { user } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Card>
        <CardHeader
          title={
            <Typography sx={{ fontSize: '1.8rem', fontWeight: '500' }}>
              Delete Account
            </Typography>
          }
        />
        <Divider />
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography marginTop=".5rem" variant="h4">
            <Typography marginTop=".5rem" sx={{ fontSize: '.9rem' }}>
              We're sorry to see you go! Your feedback is valuable to us and
              will help improve our services. Please take a moment to let us
              know why you're deleting your're deleting your account.
            </Typography>
            <Typography marginTop=".5rem" sx={{ fontSize: '.9rem' }}>
              Thank you for your time.
            </Typography>
          </Typography>

          <Formik
            initialValues={{
              reasons: [],
              other: '',
              password: '',
              otherText: false
            }}
            validationSchema={Yup.object().shape({
              reasons: Yup.array().when('otherText', (otherText, schema) => {
                if (!otherText[0])
                  return schema
                    .min(1, 'Please provide atlest 1 reason')
                    .required('Reasons is required field');
              }),
              password: Yup.string().required(
                'Please enter your password to proceed'
              ),
              other: Yup.string().when('otherText', (otherText, schema) => {
                if (otherText[0])
                  return schema.required('Please fill the input field');
              })
            })}
            onSubmit={async (values) => {
              if (values.other !== ''.trim()) {
                values.reasons.push(values.other);
              }
              values.reasons = values.reasons.filter((text) => text !== 'on');
              const result = {
                reasons: values.reasons,
                password: values.password
              };
              try {
                dispatch(startLoading());
                return deleteAdmin(user, result)
                  .then((response) => {
                    const isError = response.status !== 200;
                    const message = isError ? response?.message : "Admin Deleted Successfully"
                    setSnackbarState({
                      open: true,
                      message: message,
                      severity: isError ? 'error' : 'success'
                    });
                    if (!isError) {
                      dispatch(logoutUser());
                      navigate(CONSTANTS.ROUTES.PUBLIC_ROUTES.LOGIN);
                    }
                  })
                  .catch((err) => {
                    console.log(err, 'ERROR');
                    throw err;
                  })
                  .finally(() => dispatch(stopLoading()));
              } catch (err) {
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                  }}
                >
                  <FormControlLabel
                    control={<Checkbox />}
                    onBlur={handleBlur}
                    name="reasons"
                    onChange={handleChange}
                    onClick={(e) => {
                      e.target.checked
                        ? values.reasons.push(resons[0])
                        : (values.reasons = values.reasons.filter(
                            (text) => text !== resons[0]
                          ));
                    }}
                    label={resons[0]}
                  />
                  <FormControlLabel
                    name="reasons"
                    control={<Checkbox />}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onClick={(e) =>
                      e.target.checked
                        ? values.reasons.push(resons[1])
                        : (values.reasons = values.reasons.filter(
                            (text) => text !== resons[1]
                          ))
                    }
                    label={resons[1]}
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="reasons"
                    onClick={(e) =>
                      e.target.checked
                        ? values.reasons.push(resons[2])
                        : (values.reasons = values.reasons.filter(
                            (text) => text !== resons[2]
                          ))
                    }
                    label={resons[2]}
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="reasons"
                    onClick={(e) =>
                      e.target.checked
                        ? values.reasons.push(resons[3])
                        : (values.reasons = values.reasons.filter(
                            (text) => text !== resons[3]
                          ))
                    }
                    label={resons[3]}
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    name="reasons"
                    onClick={(e) =>
                      e.target.checked
                        ? values.reasons.push(resons[4])
                        : (values.reasons = values.reasons.filter(
                            (text) => text !== resons[4]
                          ))
                    }
                    label={resons[4]}
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    name="reasons"
                    onClick={(e) =>
                      e.target.checked
                        ? values.reasons.push(resons[5])
                        : (values.reasons = values.reasons.filter(
                            (text) => text !== resons[5]
                          ))
                    }
                    label={resons[5]}
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        onBlur={handleBlur}
                        name="otherText"
                        onChange={handleChange}
                        onClick={() => {
                          setOther((prev) => !prev);
                        }}
                      />
                    }
                    label="other"
                  />

                  <Typography color={'red'}>
                    {touched.reasons && errors.reasons}
                  </Typography>
                </Box>
                <TextField
                  sx={{ display: !other ? 'none' : '' }}
                  error={Boolean(touched.other && errors.other)}
                  helperText={touched.other && errors.other}
                  fullWidth
                  label={'Reasons'}
                  margin="normal"
                  name="other"
                  value={values.other}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="text"
                />

                <Box>
                  <Typography marginTop=".5rem" variant="h4">
                    Are you sure you want to delete your account ?
                    <Typography margin=".5rem" sx={{ fontSize: '.9rem' }}>
                      This action is irreversible and will permanently delete
                      all your account information and data associated with it.
                      You have 30-day garce priod to request re-enabling your
                      account
                    </Typography>
                  </Typography>

                  <Typography marginTop=".5rem" variant="h4">
                    Important:
                    <Typography margin=".5rem" sx={{ fontSize: '.9rem' }}>
                      <li>
                        Your account and data will be deleted permanently after
                        30 days
                      </li>
                      <li>
                        If you wish to re-enable your account within this
                        period, conatct our support
                      </li>
                    </Typography>
                  </Typography>
                </Box>

                <Typography marginTop=".5rem" variant="h4">
                  Please enter your password to confirm the deletion:
                </Typography>
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  fullWidth
                  label={'Password'}
                  margin="normal"
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    textTransform: 'none',
                    p: 2
                  }}
                >
                  <Button
                    color="error"
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {STRINGS.DELETE_ADMIN}
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </CardContent>
        <Divider />
      </Card>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
    </>
  );
};

export default DeleteAdminForm;
